import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GT_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GT_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 0h10v24H22V0zM0 0h12v24H0V0z",
      fill: "#58A5FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0h12v24H10V0z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.77 15.719l.521.683 2.37-3.212v-.569L11.77 15.72z",
      fill: "#6C301F"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.404 12.136l.174-.238c2.243 1.687 3.833 2.982 4.722 4.06l-.555.458c-.845-1.026-2.139-2.624-4.34-4.28zM17.022 10.726l-.258-.25 1.414-1.46.31.302 1.47-1.368.244.263-1.719 1.601-.297-.289-1.164 1.201z",
      fill: "#979797"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.506 8.446c-.075-.329-.16-.734-.16-.734-.19.432-.25.825-.173 1.177-.081.11-.154.215-.22.312-.203-.27-.458-.773-.458-.773.01.146.005.296.001.441-.009.341-.018.659.143.857l-.002.004a5.253 5.253 0 00-.09.197c-.221-.22-.588-.617-.588-.617.029.476.16.851.4 1.119-.043.139-.079.277-.107.415-.185-.191-.363-.38-.363-.38.026.434.098.72.287.961a3.73 3.73 0 00-.006.206c-.196-.202-.395-.412-.395-.412.028.458.207.76.442 1.01.023.146.055.29.095.432l.022.075c-.266-.129-.557-.275-.557-.275.174.4.427.621.716.776.061.179.126.352.194.52-.312-.085-.777-.225-.777-.225.276.418.615.585.98.68.073.156.15.304.23.445-.295-.083-.642-.186-.642-.186.268.406.596.575.948.672.233.33.482.602.742.806-.287.13-.647.285-.647.285.407.121.732.075 1.03-.04l.034.018c.128.06.272.119.433.175-.234.105-.458.201-.458.201a1.51 1.51 0 001.008-.032l.033.009c.143.039.288.076.48.123-.127-.03.34.085.436.109.304.077.477.131.56.178a.389.389 0 01.017.01l.005.003.233-.17a.34.34 0 00-.113-.093c-.114-.065-.3-.123-.631-.207a93.796 93.796 0 00-.445-.11 21.214 21.214 0 01-.588-.155 1.508 1.508 0 00-.214-.976s-.09.552-.152.864a4.165 4.165 0 01-.48-.189 1.792 1.792 0 01-.138-.074 1.51 1.51 0 00-.381-.94s.004.351.002.655a3.799 3.799 0 01-.547-.64l.123.066c.013-.39-.047-.773-.383-1.166 0 0 .004.38.002.691a7.19 7.19 0 01-.313-.617 1.512 1.512 0 00-.034-1.024s-.088.25-.18.504a9.53 9.53 0 01-.08-.22c.188-.316.31-.666.22-1.149 0 0-.215.38-.378.657a3.505 3.505 0 01-.116-.48c.269-.227.487-.511.564-.975 0 0-.36.31-.61.514a3.493 3.493 0 01.003-.311c.29-.176.539-.416.69-.842 0 0-.356.21-.633.367.02-.105.044-.21.073-.316v.01c.345-.183.647-.427.819-.915 0 0-.356.211-.633.368a3.646 3.646 0 01.33-.628c.307-.098.592-.266.835-.62 0 0-.245.069-.5.137.148-.201.321-.426.52-.674l-.225-.18c-.082.103-.16.201-.233.296z",
      fill: "#5AB92D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.634 8.446c.076-.329.16-.734.16-.734.19.432.25.825.174 1.177.08.11.154.215.22.312.203-.27.457-.773.457-.773a5.113 5.113 0 000 .441c.009.341.017.659-.143.857l.001.004c.032.066.063.132.091.197.22-.22.588-.617.588-.617-.029.476-.16.851-.4 1.119.043.139.078.277.107.415.185-.191.363-.38.363-.38-.026.434-.099.72-.287.961.004.07.006.138.006.206.195-.202.394-.412.394-.412-.027.458-.206.76-.441 1.01-.023.146-.055.29-.096.432l-.021.075c.266-.129.557-.275.557-.275-.174.4-.428.621-.716.776-.062.179-.127.352-.195.52.312-.085.778-.225.778-.225-.276.418-.615.585-.98.68a7.271 7.271 0 01-.23.445c.295-.083.642-.186.642-.186-.269.406-.596.575-.948.672-.233.33-.482.602-.742.806.286.13.647.285.647.285a1.512 1.512 0 01-1.03-.04 4.231 4.231 0 01-.468.193c.235.105.459.201.459.201a1.509 1.509 0 01-1.009-.032l-.032.009c-.143.039-.289.076-.48.123.127-.03-.341.085-.436.109-.304.077-.478.131-.56.178a.389.389 0 00-.018.01l-.004.003-.233-.17a.34.34 0 01.113-.093c.114-.065.3-.123.63-.207l.446-.11a21.214 21.214 0 00.588-.155 1.508 1.508 0 01.213-.976s.091.552.153.864c.184-.061.342-.123.479-.189.046-.022.093-.047.139-.074a1.51 1.51 0 01.381-.94s-.004.351-.002.655c.188-.173.372-.387.547-.64l-.123.066c-.014-.39.046-.773.383-1.166 0 0-.005.38-.003.691.11-.19.215-.397.314-.617a1.512 1.512 0 01.034-1.024s.088.25.18.504a9.53 9.53 0 00.08-.22c-.189-.316-.31-.666-.22-1.149 0 0 .214.38.378.657l.033-.113a3.48 3.48 0 00.083-.366 1.534 1.534 0 01-.564-.976s.36.31.61.514a3.493 3.493 0 00-.003-.311 1.524 1.524 0 01-.69-.842s.355.21.632.367a3.957 3.957 0 00-.073-.316v.01c-.344-.183-.646-.427-.818-.915 0 0 .356.211.633.368a3.643 3.643 0 00-.33-.628 1.514 1.514 0 01-.835-.62s.245.069.499.137c-.148-.201-.32-.426-.519-.674l.225-.18c.081.103.159.201.232.296z",
      fill: "#5AB92D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.418 9.323l1.207 3.2h-.887s-.32 1.009.284 1.009h3.714s.404-.253.202-1.01c-.202-.756-1.224-2.844-1.224-2.844s.437-.347.437-.604-.437-.285-.437-.285h-2.756c-.351.057-.54.534-.54.534z",
      fill: "#EFE298"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.445 10.5l1.875-.116-1.875.117z", fill: "#C5A042" }), /* @__PURE__ */ e.createElement("path", { d: "M14.445 10.5l1.875-.116", stroke: "#B47D00", strokeWidth: 0.5 }), /* @__PURE__ */ e.createElement("path", { d: "M14.9 11.521l1.875-.116-1.875.116z", fill: "#C5A042" }), /* @__PURE__ */ e.createElement("path", { d: "M14.9 11.521l1.875-.116", stroke: "#B47D00", strokeWidth: 0.5 }), /* @__PURE__ */ e.createElement("path", { d: "M15.258 12.542l1.875-.117-1.875.117z", fill: "#C5A042" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.258 12.542l1.875-.117",
      stroke: "#B47D00",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.88 7.588s-.288.059-.288.241-.078.338-.078.338.088.832.746 1.025c.659.193 1.044.24 1.322.627.277.387 1.127 1.48.786 2.423-.341.943-.609 1.424-.609 1.424s1.244-1.171 1.244-1.727c0-.555-.184-1.093-.735-1.798-.55-.705-.807-1.118-1.218-1.435-.41-.318-.998-.611-.998-.611s.21-.224.105-.33a1.011 1.011 0 00-.277-.177z",
      fill: "#5AB92D"
    }
  ))
);
export {
  a as default
};
